import { isWindowsConnectorHost } from './platform';
import { isExclusiveModeEnabledForDevice, type SelectedUsbDac } from './usbDacNames';
import { resolveExclusiveDeviceName } from './localOutputLogging';
import { isConnectorBitPerfectCapable } from './connectorCapability';

type ZoneLike = {
  type?: string;
  id?: string;
  name?: string;
  metadata?: { audio_device_id?: string };
} | null | undefined;

/**
 * Whether local playback should route through the native exclusive engine.
 * Windows: true when a USB DAC is resolved (local-native zone or selectedUsbDac.id).
 * macOS: unchanged — local-native always; legacy path requires uid + profile.
 */
export async function shouldRouteLocalExclusive(
  zone: ZoneLike,
  selectedUsbDac: SelectedUsbDac | null | undefined,
): Promise<boolean> {
  if (!isConnectorBitPerfectCapable()) return false;

  const zoneType = zone?.type;
  const zoneId = zone?.id;

  if (zoneType === 'local-native') return true;

  if (zoneType && zoneType !== 'local' && zoneType !== 'browser') return false;

  if (isWindowsConnectorHost()) {
    const deviceName = resolveExclusiveDeviceName(zone, selectedUsbDac);
    if (!deviceName) return false;
    return isExclusiveModeEnabledForDevice(selectedUsbDac);
  }

  if (zoneId === 'this_device' || zoneId === 'local_computer' || zoneId === 'this_computer') {
    return false;
  }

  if (!selectedUsbDac?.uid) return false;
  return isExclusiveModeEnabledForDevice(selectedUsbDac);
}
